import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "./../../index.css";
import "./../../mainslider.css"
import { Pagination } from "swiper";
import axios from 'axios';
import { baseUrl } from '../../utils/baseUrl.js';
import { Link } from 'react-router-dom';

const CategorySlider = () => {
    const [categories, setCategories] = useState([])

    const getAllCategories = async () => {
        const { data } = await axios.get(`${baseUrl}/categories`)
        setCategories(data.categories)
    }

    useEffect(() => {
        getAllCategories()
    }, [])

    return (
        <>
            {categories ?
                <div className="flex relative container gap-4 my-3">
                    <Swiper
                        breakpoints={{
                            375: {
                                width: 375,
                                slidesPerView: 2,
                            },
                            425: {
                                width: 425,
                                slidesPerView: 3,
                            },
                            576: {
                                width: 576,
                                slidesPerView: 4,
                            },
                            768: {
                                width: 768,
                                slidesPerView: 6,
                            },
                            1024: {
                                width: 1024,
                                slidesPerView: 7,
                            },
                            2048: {
                                width: 2048,
                                slidesPerView: 9,
                            },
                        }}
                        modules={[Pagination]}
                        spaceBetween={30}
                        pagination={{ clickable: true }}
                        className="h-auto cursor-pointer select-none m-auto md:rounded-lg py-8">
                        {categories.map((category, i) => (
                            <SwiperSlide key={i} className="bg-slate-800">
                                <Link to={`/categories/${category._id}`}>
                                    <img src={category.Image?.path} className="w-full" alt="" />
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div> : ""}
        </>
    )
}

export default CategorySlider